import React, { useEffect, useState } from "react";
import Layout from "../../components/layout";
import { FaArrowLeft } from "react-icons/fa";

import styles from "./SampleDetailsPage.module.scss";
import { Link, useNavigate, useParams } from "react-router-dom";
import { route } from "../../static/route";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  fetchSampleDetailsData,
  getSampleDetails,
} from "../../features/sampleDetails/sampleDetailsSlice";
import { FaFilePdf } from "react-icons/fa6";
import moment from "moment";
import { POST } from "../../services/axios.service";
import SampleCloseForm from "../../components/samples/SampleCloseForm";

const SampleDetailsPage = () => {
  const { sampleId } = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const sample = useAppSelector(getSampleDetails);

  const [isSampleCloseOpen, setIsSampleCloseOpen] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const handleGoToBack = () => {
    navigate(-1);
  };

  const handlePrintReport = async () => {
    setErrorMessage(null);
    try {
      await POST(`/v1/worker/sample-reports`, {
        sample_ids: [sample?.id],
      })
        .then(async (response: any) => {
          if (response.data.status === "success") {
            const downloadLink = response.data.data.download_link;
            try {
              const newWindow = window.open(downloadLink, "_blank");
              if (
                !newWindow ||
                newWindow.closed ||
                typeof newWindow.closed == "undefined"
              ) {
                throw new Error("પોપ્અપ બ્લોક કરેલ છે.");
              }
            } catch (e) {
              window.location.href = downloadLink;
            }
          } else {
            setErrorMessage(response.data.message);
          }
        })
        .catch((error: any) => {
          setErrorMessage(error.data.message);
        });
    } catch (error) {
      setErrorMessage("કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.");
    }
  };

  const handleCloseSample = () => {
    setIsSampleCloseOpen(true);
  };

  useEffect(() => {
    if (sampleId)
      dispatch(fetchSampleDetailsData({ sampleId: parseInt(sampleId) }));
  }, [sampleId]);

  return (
    <Layout className="print:max-h-[148mm]">
      <div className={styles.SampleDetailsPage}>
        <div className="w-full px-10 h-[200px] text-center flex flex-col justify-center relative">
          <FaArrowLeft
            onClick={handleGoToBack}
            className="absolute top-5 left-5 text-3xl text-white border-2 border-white p-1 rounded-full"
          />

          <h1 className="text-4xl mt-6 font-bold text-white">સેમ્પલ ની વિગત</h1>
        </div>

        <div className="w-full relative mt-[70px] px-10 py-5 lg:mt-[20px]">
          {sample ? (
            <div className="w-full p-6 bg-primary-2 bg-opacity-50 rounded-xl shadow mb-5">
              <h5 className="text-primary-1 text-xl font-semibold text-center">
                કામ નું આઇડી : {sample?.id || ""}
              </h5>

              <div className="flex flex-col gap-3 mt-6 text-center">
                <p className="text-primary-1 text-sm font-semibold">
                  પાર્ટી : {sample.party_name}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  આઈટમ : {sample.item_name}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  પ્રોસેસ : {sample.process_name}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  યુનિટ :{" "}
                  {sample.unit === 1
                    ? "KG"
                    : sample.unit === 2
                    ? "Piece"
                    : "Pair"}
                </p>
                <p className="text-primary-1 text-sm font-semibold">
                  {sample.unit === 3
                    ? "જોડી"
                    : sample.unit === 2
                    ? "નંગ"
                    : "વજન"}{" "}
                  : {sample.qty}
                </p>
                {sample.status === 1 && (
                  <>
                    <p className="text-primary-1 text-sm font-semibold">
                      ડિલિવર કરેલ{" "}
                      {sample.unit === 3
                        ? "જોડી"
                        : sample.unit === 2
                        ? "નંગ"
                        : "વજન"}{" "}
                      : {sample.delivered_qty}
                    </p>

                    <p className="text-primary-1 text-sm font-semibold">
                      ડિલિવર કરેલ તારીખ :{" "}
                      {moment(
                        sample.delivered_date,
                        "YYYY-MM-DD HH:mm:ss"
                      ).format("DD-MM-YYYY hh:mm A")}
                    </p>

                    <p className="text-primary-1 text-sm font-semibold">
                      અમાઉન્ટ : {sample.amount}
                    </p>
                  </>
                )}
              </div>

              <div className="w-full flex flex-col">
                <button
                  className="mx-auto flex gap-3 mt-6 shadow disabled:opacity-50 rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                  type="button"
                  onClick={handlePrintReport}
                >
                  <FaFilePdf className="text-white mt-1" />
                  PDF
                </button>

                {sample?.status === 0 && !isSampleCloseOpen && (
                  <button
                    className="mx-auto flex gap-3 mt-6 shadow disabled:opacity-50 rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                    type="button"
                    onClick={handleCloseSample}
                  >
                    પુરુ કરો
                  </button>
                )}
              </div>

              {sample?.status === 0 && isSampleCloseOpen && (
                <SampleCloseForm sample={sample} />
              )}

              {errorMessage && (
                <p className="text-red-500 text-sm font-semibold text-center">
                  {errorMessage}
                </p>
              )}
            </div>
          ) : (
            <div className="text-center">
              <p className="mt-4 text-primary-2 font-bold text-2xl">
                કામ ની વિગતો મળી નથી.
              </p>

              <div className="w-full flex justify-center">
                <Link to={route.newSample}>
                  <button
                    type="button"
                    className="mx-auto mt-8 shadow rounded-3xl text-3xl text-white bg-gradient-to-r from-primary-1 to-primary-2 font-bold px-10 py-2"
                  >
                    કામ ઉમેરો
                  </button>
                </Link>
              </div>
            </div>
          )}
        </div>
      </div>
    </Layout>
  );
};
export default SampleDetailsPage;
